import React from 'react';
import PropTypes from 'prop-types';
import Language from './Language';
import WithImpressions from '../../../WithImpressions';
import { default as languageList } from './languageList.json';
import './style.scss';

export default function Languages({ languages, biData }) {
    if (!languages.length) { return null; }

    const langs = languages.map((language) =>
        languageList.language_options.find((lang) => lang.value === language.name).name).toString();

    const seller_card_about_me_languages = {
        type: 'seller_page.show$viewport',
        seller: { id: biData.sellerId },
        group: 'seller_card_about_me_languages_impression',
        page: {
            ctx_id: biData.pageCtxId,
            component: { name: 'seller_card_about_me_languages' },
            element: {
                position: biData.position,
                type: 'text',
                metadata: 'Languages',
                text: langs,
                name: 'seller_card_about_me_languages',
                visible: true
            }
        }
    };

    return (
        <WithImpressions value={seller_card_about_me_languages} className="languages">
            <h3>{i18n.t('seller_profile.languages')}</h3>
            <ul>
                {languages.map((language, idx) => {
                    const languageNativeName = languageList.language_options.find((lang) => lang.value === language.name);

                    const languageData = {
                        name: languageNativeName.name,
                        native_name: languageNativeName.native_name,
                        level: language.level
                    };

                    return <Language language={languageData} key={idx}/>;
                })}
            </ul>
        </WithImpressions>
    );
}

Languages.propTypes = {
    languages: PropTypes.array,
    biData: PropTypes.object
};

Languages.defaultProps = {
    languages: [],
    biData: {}
};



// WEBPACK FOOTER //
// ./src/common/InfoPanel/SellerProfile/Languages/index.js